import styled from 'styled-components';
import { colors } from '@prisjakt/ui-base';
import { Hideable, HideableState } from '@regular_ui/lib/components/hideable';

import { slowRevealHideableVariant } from '@prisjakt/customization_prisjakt/variants/hideable';

export const PriceHistorySummary = styled.div.attrs({
  'data-test': 'PriceHistorySummary',
})`
  height: 140px;
  background: ${props => props.theme.bg.secondary};
`;

export const FadingBox = styled(Hideable).attrs({
  variant: slowRevealHideableVariant,
  mountState: HideableState.Gone,
  renderWhenHidden: true,
})`
  background: ${props => props.theme.bg.primary};
  border: 1px solid
    ${props => (props.isLoading ? props.theme.bg.secondary : colors.lightGray1)};
  display: block;
  padding: 10px;
`;

export const PriceHistoryHeading = styled.span`
  color: ${colors.darkGray2};
  float: left;
`;

export const PriceHistoryWrapper = styled.div`
  position: relative;
`;

export const CurrentPrice = styled.div`
  text-align: right;
  color: ${colors.darkGray2};
  font-weight: bold;
`;
